module.exports = __webpack_public_path__ + "img/106.1207d854.png";